import { useDashboard } from "@/entities/dashboard";
import { AppShell } from "@/widgets/app-shell";

import { useAuth } from "@/entities/session";
import { AppRoutes } from "../routes";

/**
 * Каркас с данными.
 *
 * Счётчики очереди берутся из той же сводки, что и главный экран: отдельной
 * ручки «сколько заявок ждёт» нет намеренно, а TanStack Query отдаёт обоим
 * потребителям один и тот же кэш.
 */
export function Shell({
  themeMode,
  onToggleTheme,
}: {
  themeMode: "light" | "dark";
  onToggleTheme: () => void;
}) {
  const { admin, isSuperadmin, logout } = useAuth();
  const { data } = useDashboard();

  if (admin === null) return null;

  return (
    <AppShell
      login={admin.login}
      role={admin.role}
      isSuperadmin={isSuperadmin}
      pending={{
        deposits: data?.counters.deposits_pending ?? 0,
        withdrawals: data?.counters.withdrawals_pending ?? 0,
        comments: data?.counters.comments_to_review ?? 0,
      }}
      themeMode={themeMode}
      onToggleTheme={onToggleTheme}
      onLogout={logout}
    >
      <AppRoutes />
    </AppShell>
  );
}
